import { FF_KEAP_UNLAYER_EMAIL_PHASE1, KEAP_UNLAYER_EMAIL_PHASE2_ENABLED } from '@/shared/constants/featureFlag.constants';

export default {
    unlayerBuilderEnabled(state, getters, rootState) {
        const { featureFlags } = rootState;

        return featureFlags[FF_KEAP_UNLAYER_EMAIL_PHASE1] || featureFlags[KEAP_UNLAYER_EMAIL_PHASE2_ENABLED];
    },
};
